import { t } from 'i18next';
import React, { useState } from 'react';
import styled from 'styled-components';
import Iphone from '../../../asset/mama/iphone.png';
import Products from '../../../asset/mama/products.png';
// import QRImg from '../../../asset/mama/qr.png';
import QRTgImg from '../../../asset/mama/qr-tg.gif';
import QRViberImg from '../../../asset/mama/qr-viber.gif';
import Starfall from '../../../asset/mama/starfall.png';
import TG from '../../../asset/mama/tg.png';
import Viber from '../../../asset/mama/viber.png';
import { TextElem } from '../../../common/text';
import { i18n } from '../../../lib/lang';
import { SIZE_FONT_ENUM } from '../../../theme/size';
import { MamaText, MamaTextLogo, PromoBadge } from './home/frame/hero';

export const Help: React.FC<{}> = ({ }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const viberHref = i18n.t('MAMA.HOME.VIBER');
  const telegramHref = i18n.t('MAMA.HOME.TELEGRAM');
  const siteHref = i18n.t('MAMA.HOME.SITE');

  return (
    <CardsRow>
      {/* Single code card */}
      <MamaCardBlock alternative>
        <PromoBadge>
          <div className="dot" />
          <span className="text">{t("MAMA.HOME.PROMO_DURATION")}</span>
        </PromoBadge>
        <CardTitle>
          <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.HELP.TITLE" color='white' />
          <MamaTextLogo size={SIZE_FONT_ENUM.TITLE_LARGE} type="extra-bold" tid="MAMA.HELP.TITLE_KEY" color='yellow' />
        </CardTitle>
        <CardDesc>
          <TextElem size="label" type='bold' tid="MAMA.HELP.DESC1" color='white' fontFamily='RF Dewi' />
          <TextElem size="label" type='bold' tid="MAMA.HELP.DESC2" color='white' fontFamily='RF Dewi' />
        </CardDesc>

        <CodesStarfallImage src={Starfall} />
        <CodesProductsImage src={Products} />
        <CodesIphoneImage src={Iphone} />
      </MamaCardBlock>

      {/* Multi code card */}
      <MamaCardBlock id="help">
        <CardTitle>
          <TextElem size={SIZE_FONT_ENUM.SIGNATURE} type="regular" tid="MAMA.HELP.QUESTIONS" color='black' />
        </CardTitle>
        <TextElemSelfLeft size={SIZE_FONT_ENUM.LABEL} type="extra-bold" tid="MAMA.HELP.CONTACT_SUPPORT" color='black' fontFamily='RF Dewi' />
        <CardDesc>
          <HelpQrContainer>
            <HelpQhHolder>
              <MamaTextStyled size={SIZE_FONT_ENUM.TITLE} type="regular" tid="TELEGRAM" color='white' />
              <HelpQrImg src={QRTgImg} />
            </HelpQhHolder>
            <HelpQhHolder>
              <MamaTextStyled size={SIZE_FONT_ENUM.TITLE} type="regular" tid="VIBER" color='white' />
              <HelpQrImg src={QRViberImg} />
            </HelpQhHolder>
          </HelpQrContainer>
        </CardDesc>
        <TextElem size="label" type="bold" tid="MAMA.HELP.SCAN_AND_GO" color='white' fontFamily='RF Dewi' />
        <HelpSocialsContainer>

          <LinkStyled target="_blank" href={telegramHref}>
            <SocialImg src={TG} />
          </LinkStyled>
          <LinkStyled target="_blank" href={viberHref}>
            <SocialImg src={Viber} />
          </LinkStyled>
          {/* <LinkStyled target="_blank" href={siteHref}>
            <SocialImg src={External} />
          </LinkStyled> */}

        </HelpSocialsContainer>
      </MamaCardBlock>
    </CardsRow >
  );
};

// ─── Layout ───────────────────────────────────────────────────────────────────

const CardsRow = styled.div`
  /* display: flex; */
  display: grid;
  grid-template-columns: 4fr 3fr;

  gap: 24px;
  width: 100%;
  padding-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    grid-template-columns: 1fr;
    /* grid-template-rows: 1fr 1fr; */
  }
`;

// ─── Cards ───────────────────────────────────────────────────────────────

const MamaCardBlock = styled.div<{ $active?: boolean; $dim?: boolean, alternative?: boolean }>`
  /* flex: 1; */
  min-width: 0;
  /* flex-shrink: 0; */
    min-height: 680px;

  text-align: ${({ alternative }) => (!alternative ? 'center' : 'left')};
  justify-content: ${({ alternative }) => (!alternative ? 'space-between' : 'left')};
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 44px;
  border-radius: 24px;
  position: relative;
  overflow: hidden;


  input {
    font-family: 'Dela Gothic One' !important;
  }

  background: ${({ alternative }) =>
    alternative
      ? 'linear-gradient(180deg, #FF0480 0%, #97003C 100%)'
      : 'linear-gradient(0deg, #FF5100 30.5%, #FFA67D 100%)'};
;

  transition: opacity 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;

  opacity: ${({ $dim }) => ($dim ? 0.45 : 1)};
  transform: ${({ $active }) => ($active ? 'scale(1.01)' : 'scale(1)')};
  box-shadow: ${({ $active }) =>
    $active
      ? '0 8px 40px rgba(227, 37, 49, 0.18)'
      : '0 2px 16px rgba(0,0,0,0.07)'};
  pointer-events: ${({ $dim }) => ($dim ? 'none' : 'auto')};


  @media (max-width: 768px) {
    min-height: 580px;
    padding: 24px;
  }

  @media (max-width: 400px) {
    min-height: 620px;
  }
`;

const CardTitle = styled.div`
  font-weight: 400;
  margin-top: 4px;
  /* display: flex; */
  /* flex-direction: column; */

  /* > * {
    display: inline;
  } */
`;

const CardDesc = styled.div`
  color: #666;
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;


const CodesIphoneImage = styled.img`
  position: absolute;
  right: -20px;
  bottom: -20px;
  z-index: -1;
  width: 300px;

  @media screen and (max-width: 1100px) {
    width: 200px;
  }
`;

const CodesProductsImage = styled.img`
  position: absolute;
  left: 60px;
  bottom: 0px;
  z-index: -1;
  width: 440px;

  @media screen and (max-width: 1100px) {
    width: 300px;
    left: -50px;
  }
`;

const CodesStarfallImage = styled.img`
  position: absolute;
  right: 0px;
  top: 0px;
  rotate: -30deg;
  transform: scaleX(-1);
  z-index: -1;
  width: 200px;

  @media screen and (max-width: 700px) {
    width: 150px;
    top: 100px;
    right: -50px;
  }

`;

const HelpQhHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  max-width: 245px;
  align-items: center;
`;

const HelpQrImg = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  border-radius: 24px;
  max-width: 200px;
`;

const HelpQrContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  
  @media screen and (max-width: 350px) {
    flex-direction: column;
  }
`;

const SocialImg = styled.img`
  min-width: 0;
`;

const HelpSocialsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  /* flex-wrap: wrap; */
  margin-bottom: 20px;
  justify-content: space-around;

    @media screen and (max-width: 410px) {
    /* flex-direction: column; */
  }
`;

const LinkStyled = styled.a`
  transition: 0.3s opacity ease;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-decoration: none;
  max-width: 150px;

  :hover {
    opacity: 0.7;
  }
`;

const MamaTextStyled = styled(MamaText)`
  overflow-wrap: normal;

  @media screen and (max-width: 1080px) {
    font-size: 14px;
  }
`;

const TextElemSelfLeft = styled(TextElem)`
  text-align: left;
`;